import React from 'react';
import FormPasswordRecover from '../components2/formPasswordRecover';

function PasswordRecover () {
    return (
        <div className='flex flex-col'>
            <FormPasswordRecover />
        </div>
    )
}

export default PasswordRecover;